<template>
  <span>
      <el-form-item label="ID:" class="query-form-item">
          <el-input style="width: 100px;" clearable v-model="query.id" placeholder="请输入ID" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="销售国家：" class="query-form-item" prop="state">
          <el-select v-model="query.category_state" style="width: 100px;" size="mini" filterable>
              <el-option v-for="item in $common.us_arr" :key="item.us" :label="item.title" :value="item.us"
                         :disabled="item.disabled">
                  <div class="keywords_arr_div">
                                <icon-svg :icon-class="item.us.toUpperCase()"
                                          style="font-size: 24px;margin-right:5px;"></icon-svg>
                      <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{
                              item.title
                          }}</span>
                  </div>
              </el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="类目：" class="query-form-item" prop="developer_id">
          <el-select v-model="query.category_id" placeholder="请选择" size="mini" filterable
                     style="width: 100px;">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.name" :value="item.id" v-for="item in filterCategoryList"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="ASIN：" class="query-form-item">
          <el-input style="width: 150px;" clearable v-model="query.asin" placeholder="请输入"
                    size="mini"></el-input>
      </el-form-item>
      <el-form-item label="是否有专利值:" class="query-form-item">
          <el-select v-model="query.has_patent_value" placeholder="状态" size="mini" style="width: 100px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="有" :value="1"></el-option>
              <el-option label="没有" :value="0"></el-option>
          </el-select>
      </el-form-item>
     <el-form-item label="标品类型：" class="query-form-item">
          <el-select v-model="query.standard_product_type" placeholder="标品类型" size="mini" style="width: 110px;">
              <el-option label="全部" value=""></el-option>
              <el-option label="未录入" :value="-1"></el-option>
              <el-option :label="item.name" :value="item.value"
                         v-for="item in standardProductTypeArr"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="选品原则：" class="query-form-item">
          <el-select v-model="query.selection_principle" placeholder="选品原则" size="mini" style="width: 100px;">
              <el-option label="全部" value=""></el-option>
              <el-option :label="item.name" :value="item.value"
                         v-for="item in selectionPrincipleList"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="是否季节性：" class="query-form-item">
          <el-select v-model="query.is_seasonality" placeholder="季节性" size="mini" style="width: 100px;">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="季节：" class="query-form-item">
          <el-select v-model="query.season" placeholder="请选择" size="mini" filterable style="width: 100px;">
              <el-option :label="item.label" :value="item.value"
                         v-for="item in $common.seasonArr"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="标题：">
          <el-input style="width: 100px;" clearable v-model="query.title"
                    placeholder="请输入" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="运输模式：" class="query-form-item">
          <el-select v-model="query.deliver_mode" placeholder="请选择" size="mini" filterable
                     style="width: 100px;">
              <el-option :label="item.label" :value="item.value"
                         v-for="item in getDeliverModeArr"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="运费差：" class="query-form-item">
          <el-input style="width: 90px;" clearable v-model="query.min_freight_difference"
                    placeholder="最小" size="mini"></el-input>
                    -
          <el-input style="width: 90px;" clearable v-model="query.max_freight_difference"
                    placeholder="最大" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="重(g)：" class="query-form-item">
          <el-input style="width: 90px;" clearable v-model="query.min_weight"
                    placeholder="最小" size="mini"></el-input>
                    -
          <el-input style="width: 90px;" clearable v-model="query.max_weight"
                    placeholder="最大" size="mini"></el-input>
      </el-form-item>

            <el-form-item label="1-9月利润：" class="query-form-item">
          <el-input style="width: 70px;" clearable v-model="query.min_early_profit"
                    placeholder="最小" size="mini"></el-input>
          -
          <el-input style="width: 70px;" clearable v-model="query.max_early_profit"
                    placeholder="最大" size="mini"></el-input>
      </el-form-item>

      <el-form-item label="利润率(含税)(%):" class="query-form-item">
          <el-input-number style="width: 110px;" clearable v-model="query.min_profit_rate"
                           placeholder="最小" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
          -
          <el-input-number style="width: 110px;" clearable v-model="query.max_profit_rate"
                           placeholder="最大" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
      </el-form-item>

      <el-form-item label="1-9月投资回报率(%):" class="query-form-item">
          <el-input-number style="width: 110px;" clearable v-model="query.min_early_investment_return_rate"
                           placeholder="最小" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
          -
          <el-input-number style="width: 110px;" clearable v-model="query.max_early_investment_return_rate"
                           placeholder="最大" size="mini" :step="0.1" :min="0" :max="100"></el-input-number>
      </el-form-item>
      <el-form-item label="批量创建：" class="query-form-item">
          <el-select v-model="query.is_batch_import" placeholder="请选择" size="mini" style="width: 100px;">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="确认销售价格：" class="query-form-item">
          <el-select v-model="query.confirm_selling_price" placeholder="请选择" size="mini" style="width: 100px;">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item label="确认1688链接：" class="query-form-item">
          <el-select v-model="query.confirm_ali_message" placeholder="请选择" size="mini" style="width: 100px;">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
          </el-select>
      </el-form-item>

  </span>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys'

export default {
    name: 'formRangeItem',
    props: ['queryTemp'],
    watch: {
        'queryTemp': {
            handler(val) {
                this.query = val
            },
            immediate: true,
            deep: true
        },
        categoryList: {
            handler() {
                const val = this.query.category_state
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
            },
            deep: true,
            immediate: true,
        },
        categoryStateProp: {
            handler(val) {
                console.log('query.category_state111---', val)
                this.filterCategoryList = ['', undefined, null].includes(val) ? this.categoryList : this.categoryList.filter(item => {
                    if (item.name.indexOf(`${val}-`) !== -1) {
                        return item
                    }
                })
                this.getDeliverModeArr = ['', undefined, null].includes(val) ? this.$common.deliverModeArr : this.$common.deliverModeArr.filter(item => item.nation == val || item.value == '')
                this.$set(this.query, 'category_id', '')
                this.$set(this.query, 'deliver_mode', '')
            },
            immediate: true,
        },
    },
    created() {
        this.getCategoryList()
        this.initFunc()
    },
    data() {
        return {
            categoryList: [],
            filterCategoryList: [],

            query: {},
            selectionPrincipleList: [],
            standardProductTypeArr: [
                {name: '标品-大众', value: '标品-大众'},
                {name: '标品-小众', value: '标品-小众'},
                {name: '非标-大众', value: '非标-大众'},
                {name: '非标-小众', value: '非标-小众'},
            ],
        }
    },
    computed: {
        categoryStateProp() {
            return this.query.category_state
        }
    },
    methods: {
        getCategoryList() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        handleQueryData() {
            let tempQuery = JSON.parse(JSON.stringify(this.query))

            if (tempQuery.min_profit_rate !== null) {
                tempQuery.min_profit_rate = tempQuery.min_profit_rate == 0 ? 0 : tempQuery.min_profit_rate / 100
            }
            if (tempQuery.max_profit_rate !== null) {
                tempQuery.max_profit_rate = tempQuery.max_profit_rate == 0 ? 0 : tempQuery.max_profit_rate / 100
            }
            if (tempQuery.min_early_investment_return_rate !== null) {
                tempQuery.min_early_investment_return_rate = tempQuery.min_early_investment_return_rate == 0 ? 0 : tempQuery.min_early_investment_return_rate / 100
            }
            if (tempQuery.max_early_investment_return_rate !== null) {
                tempQuery.max_early_investment_return_rate = tempQuery.max_early_investment_return_rate == 0 ? 0 : tempQuery.max_early_investment_return_rate / 100
            }
            return tempQuery
        },
        initFunc() {
            api.manager_index_get_category_message().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.categoryList = res.data || []
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
            api.cost_analysis_selfbuild_get_selection_principle().then(res => {
                this.loading = false
                if (res.code === 0) {
                    this.selectionPrincipleList = (res.data || []).map(item => {
                        return {name: item, value: item}
                    })
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            })
        },
    }
}
</script>

